import { render, staticRenderFns } from "./TusFileDrop.vue?vue&type=template&id=0a4a127d&"
import script from "./TusFileDrop.vue?vue&type=script&lang=ts&"
export * from "./TusFileDrop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports